module.exports = __webpack_public_path__ + "img/logo_tipografico.9cedf79d.svg";